export default {
  INITIAL_RESULT_COUNT: 100,
  RESULT_COUNT_INCREMENT: 100,
  RESULT_COUNT_INCREMENT_MEDIUM: 25,
};
